var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51.28px",
    height: "47.202px",
    viewBox: "0 0 51.28 47.202",
    enableBackground: "new 0 0 51.28 47.202",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 4.14,
    y: 1,
    width: 38.955,
    height: 43.902
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M35.985,30.68c-2.144,0-4.046,0.97-5.347,2.471l-12.762-7.66 c0.302-0.791,0.487-1.642,0.487-2.54c0-0.893-0.183-1.741-0.485-2.528l12.767-7.662c1.301,1.496,3.201,2.461,5.34,2.461 c3.928,0,7.111-3.183,7.111-7.111S39.912,1,35.985,1s-7.111,3.183-7.111,7.111c0,0.895,0.183,1.744,0.485,2.533l-12.762,7.662 c-1.303-1.499-3.203-2.466-5.345-2.466c-3.928,0-7.111,3.183-7.111,7.111s3.183,7.111,7.111,7.111c2.137,0,4.034-0.965,5.337-2.456 l12.767,7.662c-0.299,0.789-0.482,1.632-0.482,2.523c0,3.928,3.183,7.111,7.111,7.111s7.111-3.183,7.111-7.111 S39.912,30.68,35.985,30.68"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.6b1a0f6b6d7024cdd8dafa4849b2e531.svg";
export { ForwardRef as ReactComponent };